import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
`;
export const Container = styled.div``;

export const ContainerError = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
  align-content: center;
  text-align: center;
  gap: 2rem;
  padding: 32px;

  h1 {
    font-size: 28px;
    font-weight: bold;
    color: var(--color-error);
  }
  p {
    font-size: 24px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  gap: 3rem;
  justify-content: center;

  @media (max-width: 760px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Button = styled.button<{ outline?: boolean }>`
  height: 60px;
  min-height: 60px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  border: ${({ outline }) => (outline ? '1px solid var(--color-primary)' : 0)};
  color: ${({ outline }) =>
    outline ? 'var(--color-primary)' : 'var(--color-white)'};
  border-radius: 8px;
  background-color: ${({ outline }) =>
    outline ? 'var(--color-white)' : 'var(--color-primary)'};
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.2);

  cursor: pointer;
  transition: box-shadow 0.4s;

  &:hover {
    box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  }
`;
